import React from "react";
import styles from "./AIBrokerage.module.css";

const features = [
  {
    icon: "📊",
    title: "Personalised Portfolio Intelligence",
    desc: "Our AI builds and rebalances your portfolio based on your risk profile, goals, and live market signals — continuously, not just once.",
  },
  {
    icon: "🔍",
    title: "Deep Market Research",
    desc: "Get AI-summarised research reports, earnings analysis, and sector insights distilled from thousands of data sources every day.",
  },
  {
    icon: "⚡",
    title: "Instant Risk Assessment",
    desc: "Every investment decision is scored for risk before you act — so you always know exactly what you're getting into.",
  },
];

const AIBrokerage = () => {
  return (
    <div className={styles.page}>
      <div className={styles.hero}>
        <span className={styles.badge}>Coming Soon</span>
        <h1 className={styles.headline}>
          The Future of Investing,<br />Powered by AI
        </h1>
        <p className={styles.subtext}>
          We're building a next-generation brokerage platform that puts the power
          of artificial intelligence directly in your hands. Smarter decisions,
          faster execution, and personalised insights — all in one place.
        </p>
      </div>

      <div className={styles.featuresSection}>
        <h2 className={styles.featuresTitle}>What's Coming</h2>
        <div className={styles.grid}>
          {features.map((f, i) => (
            <div key={i} className={styles.card}>
              <div className={styles.cardIcon}>{f.icon}</div>
              <h3 className={styles.cardTitle}>{f.title}</h3>
              <p className={styles.cardDesc}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AIBrokerage;